export const FETCH_GAMERULES_SUCCESS = 'gamerules:FETCH_GAMERULES_SUCCESS'
export const FETCH_GAMERULES_FAIL = 'gamerules:FETCH_GAMERULES_FAIL'
export const FETCH_GAMERULES_BEGIN = 'gamerules:FETCH_GAMERULES_BEGIN'
export const INCREMENT_COUNTER = 'gamerules:INCREMENT_COUNTER'
